<template>

<v-dialog v-model="dialog" width="600px">
  <v-card>
    <p class=".title ma-2">Add a discount code </p>
    <v-form ref="addAkcd" v-model="addAkcdValid">
     
     <v-row no-gutters>  
       <v-col class="px-2" cols=9>
         <v-text-field v-model="akcd.akcd_oms" label="Description"></v-text-field>
       </v-col>  
     </v-row>  
     <v-row no-gutters>
       <v-col class="px-2" cols=3>
         <v-text-field v-model="akcd.akcd_verk_kort_bedr" type="number" label="Discount amount" prefix="EUR"></v-text-field>
       </v-col>  
       <v-col cols=1>OR
       </v-col>  
       <v-col class="px-2" cols=3>
         <v-text-field v-model="akcd.akcd_verk_kort_perc" type="number" label="Discount percentage" suffix="%"></v-text-field>
       </v-col>  
       <v-col class="px-2" cols=3>
         <v-text-field v-model="akcd.akcd_verk_kort_perc_max_bedrag" type="number" label="Max discount amount" prefix="EUR"></v-text-field>
       </v-col>    
     </v-row>


     <v-row no-gutters>
       <v-col class="px-2" cols=4>  
         <v-select v-model="akcd.akcd_unique_akcc" :items="akcd_unique_akcc_nrKeuzes" item-value="unique_nr" item-text="unique_oms" label="Unique discount codes"></v-select>
      </v-col> 
     </v-row>  

     <v-row no-gutters>
       <v-col class="px-2" cols=4>  
         <v-select v-model="akcd.bedr_codes" :items="bedr_codesKeuzes" multiple item-value="bedr_code" item-text="bedr_oms" label="Accommodation company"></v-select>
      </v-col>
      <v-col class="px-2" cols=4>  
         <v-select v-model="akcd.land_codes" :items="land_codesKeuzes" multiple item-value="land_code" item-text="land_oms" label="Accommodation countries"></v-select>
      </v-col>
     </v-row>   

     <v-row no-gutters>
       <v-col class="px-2" cols=4>
         <v-text-field v-model="akcd.akcd_boek_bedrag_min" type="number" label="Booking amount Minimum" prefix="EUR"></v-text-field>
       </v-col>
       <v-col class="px-2" cols=4>
         <v-text-field v-model="akcd.akcd_boek_bedrag_max" type="number" label="Booking amount Maximum" prefix="EUR"></v-text-field>
       </v-col>    
     </v-row>


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addAkcd" :disabled="!addAkcdValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addAkcdValid: false,
      akcd : {},
      akcd_unique_akcc_nrKeuzes: [],
      bedr_codesKeuzes: [],
      land_codesKeuzes: []
    }
  },
  methods: {
    open() {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/getToAddAkcd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getToAddAkcd"
          },
          getToAddAkcd: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.akcd = res.data.getToAddAkcd;
            res.data.getToAddAkcd.akcd_unique_akcc_nrKeuzes.forEach(function(unique) {
             deze.akcd_unique_akcc_nrKeuzes.push(unique); 
            });
            res.data.getToAddAkcd.bedr_codesKeuzes.forEach(function(bedr) {
             deze.bedr_codesKeuzes.push(bedr);
             if (bedr.bedr_selected === true) {
               deze.akcd.bedr_codes.push(bedr.bedr_code);
             } 
            });
            res.data.getToAddAkcd.land_codesKeuzes.forEach(function(land) {
             deze.land_codesKeuzes.push(land);
             if (land.land_selected === true) {
               deze.akcd.land_codes.push(land.land_code);
             } 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addAkcd() { 
      this.$axios
        .post("ares/json/ares/syst/ref/akcd/addAkcd.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addAkcd"
          },
          addAkcd: {
            akcd_oms: this.akcd.akcd_oms,
            akcd_verk_kort_perc : parseFloat(this.akcd.akcd_verk_kort_perc),
            akcd_verk_kort_bedr : parseFloat(this.akcd.akcd_verk_kort_bedr),
            akcd_verk_kort_perc_max_bedrag : parseFloat(this.akcd.akcd_verk_kort_perc_max_bedrag),
            akcd_unique_akcc: this.akcd.akcd_unique_akcc,
            bedr_codes: this.akcd.bedr_codes,
            land_codes: this.akcd.land_codes,
            akcd_boek_bedrag_min : parseFloat(this.akcd.akcd_boek_bedrag_min),
            akcd_boek_bedrag_max : parseFloat(this.akcd.akcd_boek_bedrag_max)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            if (res.data.addAkcd.color == "success") {
                this.$router.reload('/syst/ref/akcd/searchAkcd');  
             }
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addAkcd.text,
              color: res.data.addAkcd.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

